/* ***************************************
This mixin "exposes" the methods:
  * moveToNextWord() [for ManualNikudPane (&KeyMap), NikudOptionsPane, EditNikudPane, and NikudEdit]
  * moveToPreviousWord() [for ManualNikudPane and NikudEdit]
  * moveToWordMethod() [for NikudResultsContainer and NikudEdit]
(all else should be considered "internal")
*************************************** */

export default {
  name: 'navigationMixins',
  methods: {
    moveToNextWord (mode = 'auto') {
      const currentWordIndex = this.$store.state.currentPositionData.wordIndex
      /* const currentWordObj = currentWordIndex >= 0 // if index = -1 then currentWordObj = null
                              ? this.$store.state.allWorkingNikud.wordsArray[currentWordIndex] : null
      const newWordIndex = currentWordObj // if positioned IN a sepBefore, just auto-jump OUT of it
        && this.$store.state.currentPositionData.letterIndex < currentWordObj.sepBefore.length && mode === 'auto'
          ? currentWordIndex : currentWordIndex + 1 */
      var newWordIndex = currentWordIndex + 1
      while (newWordIndex < this.$store.state.allWorkingNikud.wordsArray.length
        && !(this.$store.state.allWorkingNikud.wordsArray[newWordIndex].wasAnAbbreviation)) newWordIndex++
      if (newWordIndex < this.$store.state.allWorkingNikud.wordsArray.length) {
        this.$store.commit('SET_WORD_AND_LETTER', {
          word: newWordIndex,
          letter: mode === 'auto'
            ? this.$store.state.allWorkingNikud.wordsArray[newWordIndex].sepBefore.length
            : 0
        })
      }
    },
    moveToPreviousWord (mode = 'auto') {
      const currentWordIndex = this.$store.state.currentPositionData.wordIndex
      var newWordIndex = currentWordIndex - 1
      while (newWordIndex >= 0
        && !(this.$store.state.allWorkingNikud.wordsArray[newWordIndex].wasAnAbbreviation)) newWordIndex--
      if (newWordIndex >= 0) {
        const previousWord = this.$store.state.allWorkingNikud.wordsArray[newWordIndex]
        this.$store.commit('SET_WORD_AND_LETTER', {
          word: newWordIndex,
          letter: mode === 'auto' ? previousWord.sepBefore.length : previousWord.sepBefore.length 
                                                                    + previousWord.standardLetterArray.length 
                                                                    + previousWord.sepAfter.length - 1
        })
        this.scrollResultsWindow()
      }
    },
    moveAfterEditingWordGroupIfNeeded () {
      const needToMove = (this.localCurrentLetterIndex >= (this.localCurrentWord.sepBefore.length 
                                            + this.localCurrentWord.standardLetterArray.length 
                                            + this.localCurrentWord.sepAfter.length - 1))
      if (needToMove) this.moveToNextWord()      
    },
    moveToWordMethod (wordIndex) {
      this.$store.commit('SET_WORD_AND_LETTER', {
        word: wordIndex,
        letter: this.$store.state.allWorkingNikud.wordsArray[wordIndex].sepBefore.length
      })
    }
  }
}
